import React from "react";
import * as styles from "@styles/Subscription.css";
import { Button } from "@components/ui/button";
import { Input } from "@components/ui/input";
import type { EmitOnAction, StateUpdate } from "@ps-bridge/capabilitiesTypes";
import type { ChooseSubscriptionViewProps } from "@ps-bridge/contracts/chooseSubscription";
import * as IO from "@ps-bridge/interop/io";
import * as Option from "@utils/Option";
import { onInputAction } from "@view/effects/inputHandlers";

type PromoCodeSectionContractProps = Pick<
  ChooseSubscriptionViewProps,
  "loading" | "loadingPromo"
>;

type PromoCodeSectionViewProps = PromoCodeSectionContractProps & {
  promoCode: string;
  errorView: React.ReactElement;
  onPromoCodeChange: StateUpdate<string>;
  onApplyPromoCode: EmitOnAction<string>;
};

const PromoCodeSectionView: React.FC<PromoCodeSectionViewProps> = ({
  promoCode,
  loading,
  loadingPromo,
  errorView,
  onPromoCodeChange,
  onApplyPromoCode,
}) => (
  <>
    <p className={styles.textHeading}>
      If you have a promo code, please enter it below. This will allow you to submit a survey instead of a payment method to start your trial.
    </p>

    <div className={styles.promoInput}>
      <Input
        data-testid="choose-subscription-promo-input"
        placeholder="Enter Promo Code"
        value={promoCode}
        onChange={onInputAction(onPromoCodeChange)}
      />
    </div>
    {errorView}

    <Button
      data-testid="choose-subscription-apply-promo"
      onClick={() => IO.run(onApplyPromoCode(promoCode))}
      disabled={loading || loadingPromo}
      className={styles.button}
      asChild={Option.none()}
    >
      {loadingPromo ? "Applying..." : "Apply Promo Code"}
    </Button>
  </>
);

export default PromoCodeSectionView;
